import {createPointSourceFeature} from "./createPointSourceFeature";
import {IFeature_Collection_CONO} from "../types";

export function createSource (featureCollection: IFeature_Collection_CONO) {
    return {
        type: 'geojson',
        data: featureCollection
    }
}


export function createPointSource (featureCollection: IFeature_Collection_CONO) {
    featureCollection.features = featureCollection.features.map(
        createPointSourceFeature
    );

    return createSource(featureCollection);
}